/**
 * Timeline component
 * Adjusts the timeline line height to stop at the last dot
 */

class Timeline {
    constructor() {
        this.timelineBlocks = document.querySelectorAll('.timeline-block');
        this.init();
    }

    init() {
        this.timelineBlocks.forEach(timeline => {
            this.adjustTimelineLine(timeline);
        });
    }

    adjustTimelineLine(timeline) {
        const line = timeline.querySelector('.timeline-block__line');
        const phases = timeline.querySelectorAll('.timeline-block__phase');
        
        if (!line || phases.length === 0) {
            return;
        }

        // Get the last phase
        const lastPhase = phases[phases.length - 1];
        
        // Get the position of the last dot relative to the timeline container
        const lastDot = lastPhase.querySelector('.timeline-block__dot');
        if (!lastDot) {
            return;
        }

        const timelineContainer = timeline.querySelector('.timeline-block__container');
        if (!timelineContainer) {
            return;
        }

        // Get the line's current position to use as reference
        const lineRect = line.getBoundingClientRect();
        const lastDotRect = lastDot.getBoundingClientRect();
        
        // Calculate the distance from the line's top to the center of the last dot
        const dotCenterY = lastDotRect.top + (lastDotRect.height / 2) - lineRect.top;
        
        // Set the line height to stop at the center of the last dot
        line.style.height = `${dotCenterY}px`;
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new Timeline();
});

// Re-initialize on window resize
window.addEventListener('resize', () => {
    new Timeline();
});
